/**
 * Creates a unique DOM element ID for the given panel by using its UUID.
 *
 * @param uuid
 * @return {string}
 */
export const getPanelElementId = ({ uuid }) => `stackPanel_${uuid}`;

export default {
  getPanelElementId,
};



// WEBPACK FOOTER //
// ./resources/assets/js/view-stack/utils/helpers.js